import React from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';

class ModalDefault extends React.PureComponent {
  componentDidMount() {
    if (this.getModalParent()) {
      Modal.setAppElement('#gluware-react-app');
    }
  }

  getModalParent = () => document.querySelector('#gluware-react-app');

  render() {
    return (
      this.getModalParent() && (
        <Modal
          ariaHideApp={false}
          parentSelector={this.getModalParent}
          isOpen={this.props.isOpen}
          // eslint-disable-next-line max-len
          className={
            this.props.customClass
              ? `${this.props.modalClass} ${this.props.customClass}`
              : `${this.props.modalClass}`
          }
          overlayClassName={this.props.overlayClass}
        >
          {this.props.children}
        </Modal>
      )
    );
  }
}

ModalDefault.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  modalClass: PropTypes.string,
  customClass: PropTypes.string,
  overlayClass: PropTypes.string,
};

ModalDefault.defaultProps = {
  children: null,
  isOpen: false,
  modalClass: 'glu-modal',
  customClass: '',
  overlayClass: 'glu-modal__overlay',
};

export default ModalDefault;
